﻿import React from "react";
import ReactDOM from "react-dom/client";
import "./Styles/variables.css";
import "./Styles/globals.css";
import "./i18n";
import App from "./App.jsx";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

